export default "__VITE_ASSET__3bc2c6b7__"